// Module
var code = "<react-component name=\"GoCardlessMandatesReport\"></react-component>\n";
// Exports
module.exports = code;